import { SCORE_COLORS, SCORE_DASHARRAY } from '../../helpers/scoreColors'

// AI-CONTEXT: See docs/features/analytics-card-redesign.md
// Line-style swatch for a single score (result solid · bench dotted), in the
// score's brand colour. Used in the ScoreBlock cells and the
// chart legend so a swatch always matches the line drawn in the graph.

/**
 * @param {object} props
 * @param {'result' | 'bench'} props.kind - Which score the swatch represents
 * @param {number} [props.width] - Swatch width in px (default 30)
 */
const ScoreSwatch = ({ kind, width = 30 }) => {
    const color = SCORE_COLORS[kind]
    const dash = SCORE_DASHARRAY[kind]
    const isBroken = dash !== ''
    return (
        <svg
            className="score-swatch"
            width={width}
            height={12}
            viewBox={`0 0 ${width} 12`}
            aria-hidden="true"
            focusable="false"
        >
            <line
                x1={1}
                y1={6}
                x2={width - 1}
                y2={6}
                stroke={color}
                strokeWidth={3.4}
                strokeLinecap={isBroken ? 'round' : 'butt'}
                strokeDasharray={dash || undefined}
            />
            {/* the result line carries a node marker; the benchmark line does not */}
            {kind !== 'bench' && (
                <circle cx={width / 2} cy={6} r={3.2} fill="#fff" stroke={color} strokeWidth={2.4} />
            )}
        </svg>
    )
}

export default ScoreSwatch
